// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetClassContentItemModel from '../../model/widget-class-content-item-model';
import WidgetClassContentItemDTO from '../dto/widget-class-content-item-dto';
import dtoSchema from '../schemas/widget-class-content-item-schema';

export default abstract class WidgetClassContentItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetClassContentItemDTO>) {
    super();
    if (data) {
      this.order = data.order;
      this.isBulletPoint = data.isBulletPoint;
      this.text = data.text ?? undefined;
      this.wordText = data.wordText ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  order?: number;
  /**
  */
  isBulletPoint?: boolean;
  /**
  */
  text?: string;
  /**
  * @readonly
  */
  wordText?: string;

  static toModel(dto: DeepPartial<WidgetClassContentItemDTO>): WidgetClassContentItemModel;
  static toModel(dto: DeepPartial<WidgetClassContentItemDTO> | undefined | null): WidgetClassContentItemModel | undefined;
  static toModel(dto: DeepPartial<WidgetClassContentItemDTO> | undefined | null): WidgetClassContentItemModel | undefined {
    return dto ? new WidgetClassContentItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetClassContentItemModel> | WidgetClassContentItemModel): WidgetClassContentItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      order: unwrapped.order,
      isBulletPoint: unwrapped.isBulletPoint,
      text: unwrapped.text,
      wordText: unwrapped.wordText,
    } as WidgetClassContentItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetClassContentItemModel, can not map to WidgetClassContentItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
